<template>
	<div class="address">
		<Header title="我的地址" background="white" @clickRight="clickRight">
			<template #right> 确定 </template>
		</Header>
		<van-list v-model="loading" :finished="finished" @load="onLoad" finishedText="" loadingText="">
			<div>
				<div class="list-item" v-for="item in list" :key="item.id">
					<div class="flex-center">
						<img :src="item.id == selectId ? chose : nochose" class="icon" @click="setDef(item)"
							v-if="select" />
						<img :src="item.isDefault ? chose : nochose" class="icon" @click="setDef(item)" v-else />
						<div class="right-box">
							<div class="flex-row">
								<p class="name-block">{{ item.name }}</p>
								<p>{{ item.mobile }}</p>
							</div>
							<div class="flex-row">
								<p>{{ item.areaName }}{{ item.address }}</p>
							</div>
						</div>
					</div>
					<div class="flex-center">
						<p class="small-icon" @click="$router.push(`/my/address/form?id=${item.id}`)">
							<img src="../../../assets/img/address/list_compile@2x.png" />
							<span>编辑</span>
						</p>
						<p class="small-icon">
							<img src="../../../assets/img/address/list_compile@2x.png" />
							<span @click="del(item.id)">删除</span>
						</p>
					</div>
				</div>
			</div>
			<router-link to="/my/address/form" class="btnCom">新增地址</router-link>
		</van-list>
	</div>
</template>

<script type="text/ecmascript-6">
	// import SimpleScrollList from "../../../components/SimpleScrollList.vue";
	export default {
		data() {
			return {
				loading: false,
				finished: false,
				list: [],
				form: {
					lastId: 0,
					page: 1,
				},
				defAdd: -1,
				chose: require("../../../assets/img/address/chose@2x.png"),
				nochose: require("../../../assets/img/address/no-chose.png"),
				select: false,
				selectId: "",
				info: {}
			};
		},
		methods: {
			onLoad() {
				this.$post({
					module: "Address",
					interface: "2000",
					data: this.form,
				}).then((res) => {
					// console.log("地址", res);
					this.form.page++;
					this.form.lastId = res.lastId;
					this.list = this.list.concat(res.list);
					if (res.lastPage == res.currentPage) {
						this.finished = true;
					}
					this.loading = false;
				});
			},
			clickRight(cb) {
				// localStorage.setItem("ADDRESS_ID_INFO", this.selectId);
				// this.$router.back();
				this.$router.replace({
					path: '/classify/commodity/order',
					query: {
						id: this.selectId,
						info: this.info
					}
				})
				cb();
			},
			setDef(item) {
				if (this.select && this.selectId != item.id) {
					this.selectId = item.id;
					return;
				} else if (this.select || item.isDefault) {
					return;
				}
				this.$dialog
					.confirm({
						title: "设置默认地址",
						message: "确定将此地址设置为默认地址吗？",
						cancelButtonText: "取消",
						confirmButtonText: "确定",
						cancelButtonColor: "#1677FF",
						confirmButtonColor: "#1677FF",
						className: "confirm-dialog",
					})
					.then(() => {
						this.$post({
							module: "Address",
							interface: "2003",
							data: {
								id: item.id,
								isDefault: 1,
							},
						}).then(() => {
							this.$toast("设置成功");
							this.$func.sleep().then(this.refresh);
						});
					})
					.catch(() => {});
			},
			refresh() {
				this.loading = true;
				this.list = [];
				this.finished = false;
				this.form.page = 1;
				this.form.lastId = 1;
				this.onLoad();
			},
			del(id) {
				this.$dialog
					.confirm({
						title: "删除",
						message: "确定要删除该地址吗？",
						cancelButtonText: "取消",
						confirmButtonText: "删除",
						cancelButtonColor: "#1677FF",
						confirmButtonColor: "#1677FF",
						className: "confirm-dialog",
					})
					.then(() => {
						this.$post({
							module: "Address",
							interface: "2004",
							data: {
								id,
							},
						}).then(() => {
							this.$toast("删除成功");
							this.$func.sleep().then(this.refresh);
						});
					})
					.catch(() => {});
			},
		},
		// SimpleScrollList
		components: {},
		created() {
			this.selectId = this.$route.query.select;
			this.select = this.selectId !== undefined;
			// 传过来的info是订单信息 加密的
			this.info = this.$route.query.info ? this.$route.query.info : "";
		},
	};
</script>

<style scoped lang="less">
	.address {
		background: #f7f7f7;
		font-family: PingFangSC-Medium, PingFang SC;

		.icon {
			width: 22px;
			height: 22px;
		}

		.list-item {
			background-color: #fff;
			border-radius: 8px;
			margin-bottom: 12px;

			&:last-child {
				margin-bottom: 60px;
			}

			&>.flex-center:first-child {
				padding: 16px 12px 10px;
			}

			&>.flex-center:last-child {
				padding: 10px 12px 8px;
				border-top: 1px solid #f0f0f0;
				justify-content: flex-end;
			}

			.small-icon {
				font-size: 12px;
				color: #999999;

				&>img {
					width: 12px;
					height: 12px;
					margin-right: 2px;
					vertical-align: middle;
				}

				&:first-child {
					margin-right: 20px;
				}
			}

			.right-box {
				flex: 1;
				padding-left: 12px;

				.flex-row {
					display: flex;
					align-items: flex-end;
					font-size: 12px;
					font-family: Helvetica;
					color: #999999;

					.name-block {
						font-family: PingFangSC-Medium, PingFang SC;
						font-size: 14px;
						color: #333;
						margin-right: 4px;
						font-weight: bold;
					}

					&:last-child {
						margin-top: 4px;
					}
				}
			}
		}

		// .simple-scroll-list {
		//   height: calc(100vh - 40px);
		//   padding: 16px;

		//   .btnCom {
		//     position: sticky;
		//     bottom: 0;
		//     display: block;
		//     font-size: 18px;
		//   }
		// }
		.btnCom {
			// position: sticky;
			position: fixed;
			bottom: 0;
			display: block;
			font-size: 18px;
		}
	}
</style>
